import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import { Table } from 'app-components';
import { IColumns } from '../../../../components/common/app-components/Table';
import { TXN_TYPES } from '../../../../constants/enrollmentList/enrollmentList.constant';
import { IEnrollee } from '../common/types';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import EnrollmentTxnTypeReason from './EnrolleeTxnReasonRenderer';
import EnrollmentTxnTypeRenderer from './EnrolleeTxnTypeRenderer';

const StyledSection = styled.section`
    margin: 20px 0;
    select {
        min-width: 150px;
    }
`;

interface IEnrollmentTxnTable {
    heading?: string;
}

const EnrollmentTxnTable: React.FC<IEnrollmentTxnTable> = ({ heading }) => {
    const { isEdit } = useContext(EnrollmentContext);
    const { watch } = useContext(AddOrChangeTxnFormContext);
    const values = watch();
    const getColumnDefination = useMemo(() => {
        let columns: IColumns[] = [
            {
                titleId: 'button.nothing',
                key: 'checkox',
                render: (enrollee: IEnrollee) => <EnrollmentTxnTypeRenderer enrollee={enrollee} />,
            },
            {
                titleId: 'ssap.input.label.reason',
                key: 'reason',
                render: (enrollee: IEnrollee) => <EnrollmentTxnTypeReason enrollee={enrollee} />,
            },
            {
                titleId: 'member.enrollment_list.premiumhistory.enrollee.name',
                key: 'name',
                render: enrollee => (
                    <>{`${enrollee?.firstName} ${enrollee?.middleName || ''}
                    ${enrollee?.lastName}`}</>
                ),
            },
            {
                titleId: 'member.enrollment_list.premiumhistory.enrollee.type',
                key: 'relationshipToSubscriber',
            },
            {
                titleId: 'member.enrollment_list.premiumhistory.benfifitEffectiveDate',
                key: 'enrolleeEffectiveStartDateUI',
            },
            {
                titleId: 'member.enrollment_list.premiumhistory.enrollee.benefitEndDate',

                key: 'enrolleeEffectiveEndDateUI',
            },
            {
                titleId: 'member.enrollment_list.premiumhistory.enrollee.memberId',
                key: 'memberId',
            },
        ];

        !isEdit && columns.splice(1, 1);

        return columns;
    }, [values.enrolleeDataDtoList]);

    const getEnrolleeData = useMemo(() => {
        if (isEdit && values.enrollmentLevelTxnType === TXN_TYPES.Term) {
            return [values.enrolleeDataDtoList[0]];
        }
        return values.enrolleeDataDtoList;
    }, [values.enrollmentLevelTxnType, values.enrolleeDataDtoList]);

    return (
        <StyledSection>
            <Table columns={getColumnDefination} data={getEnrolleeData} />
        </StyledSection>
    );
};

export default EnrollmentTxnTable;
